import React, { Component } from "react";
import { withApollo } from "react-apollo";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Input,
  Table,
  Icon,
  Button,
  Form,
  DatePicker,
  Avatar,
  Modal,
  Checkbox,
  TimePicker,
} from "antd";
import moment from "moment";
import { changeFormatdate } from "../../../../../utils/formatdate";
import { alertMessage } from "../../../../../utils/message";
import { configConsumerProps } from "antd/lib/config-provider";
import { isLoggedIn } from "../../../../../utils/auth";
import { UrlAbstainTime, getToken } from "../../../../../utils/auth";
import { apiKeyNews } from "../../../../../utils/apiKey";
import axios from "axios";

const { TextArea } = Input;
const timeFormat = "HH:mm";

class SecAbstainDate extends Component {
  state = {
    disabledDateStart: null,
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
    dataTableDate: [
      // {
      //   isApprove: false,
      //   startAbstainDate: moment(),
      //   endAbstainDate: "-",
      //   listNo: "8.30",
      //   //abTimeDtId: "16.30",
      //   abTimeHdId: "-",
      //   abstainDays: "-",
      //   description: "1",
      //   abstainDays: "-",
      //   isShowEditButton: true,
      //   isShowSaveButton: false,
      //   isValidate: true,
      //   disabledRow: true,
      // },
      // {
      //   isApprove: false,
      //   startAbstainDate: moment(),
      //   endAbstainDate: "-",
      //   listNo: "8.30",
      //   //abTimeDtId: "16.30",
      //   abTimeHdId: "-",
      //   abstainDays: "-",
      //   description: "2",
      //   abstainDays: "-",
      //   isShowEditButton: true,
      //   isShowSaveButton: false,
      //   isValidate: true,
      //   disabledRow: true,
      // },
      // {
      //   isApprove: false,
      //   startAbstainDate: moment(),
      //   endAbstainDate: "-",
      //   listNo: "8.30",
      //   // abTimeDtId: "16.30",
      //   abTimeHdId: "-",
      //   abstainDays: "-",
      //   description: "3",
      //   abstainDays: "-",
      //   isShowEditButton: true,
      //   isShowSaveButton: false,
      //   isValidate: true,
      //   disabledRow: true,
      // },
    ],
    pageData: {
      offset: 0,
      limit: 10,
    },
    columns: [
      {
        
        title: () => {
          return   this.props.viewModeApproves && this.props.statusDoc == "pending" || this.props.statusDoc == "draft" || this.props.statusDoc == "cancel"  || !this.props.docId?
          
          <>
              ลำดับ
            </>
            
          :
          this.props.statusDoc == "approve" || this.props.statusDoc == "reject" || this.props.approveStatus != "pending" ?
          
          <>
              อนุมัติ
            </>
            
          :
          !this.props.viewModeApproves ? (
            <>
              <Checkbox
                // disabled={ this.state.selectStatus == 'pending' || this.state.selectStatus == ''  ? false : true }
                // checked={ this.state.checkBoxTitle }
                className="checkBox-select mr-2"
                onChange={(e) => this.onChangeSlectAll(e.target.checked)}
              />
              อนุมัติ
            </>
          )
          : (
            "ลำดับ"
          );
        },
        dataIndex: "isApprove",
        keys: 1,
        vertical: "top",
        width: 60,
        align: "center",
        //hidden: true,
        render: (item, record, index) => {
          return (
            <>
            {console.log("approveDataObject",this.state.approveDataObject)}
              {!this.props.viewModeApproves || this.props.statusDoc == "approve" || this.props.statusDoc == "reject" ? (
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.propFormInput.getFieldDecorator(
                    `tbAbstainTimeDt[${index}].isApprove`,
                    {
                      initialValue: record.isApprove ? record.isApprove : false,
                    }
                  )(
                    //<Checkbox.Group style={{ width: '100%' }}>
                    <Checkbox
                      onChange={(e) => this.onChangeCheck(e, index)}
                      disabled={this.props.statusDoc == "approve" || this.props.statusDoc == "reject" || this.props.approveStatus != "pending" ? true : false}
                      //checked={record.isApprove ? record.isApprove : false}
                      checked={item}
                    />
                    //</Checkbox.Group>
                  )}
                </Form.Item>
              ) : (
                <span style={{ lineHeight: "40px" }}>{index + 1}</span>
              )}
              <Form.Item style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  `tbAbstainTimeDt[${index}].listNo`,
                  {
                    initialValue: index + 1,
                  }
                )(<Input />)}
              </Form.Item>
              <Form.Item style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  `tbAbstainTimeDt[${index}].isValidate`
                )(<Input />)}
              </Form.Item>
              <Form.Item style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  `tbAbstainTimeDt[${index}].disabledRow`
                )(<Input />)}
              </Form.Item>
              <Form.Item style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  `tbAbstainTimeDt[${index}].isShowEditButton`
                )(<Input />)}
              </Form.Item>
              <Form.Item style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  `tbAbstainTimeDt[${index}].isShowSaveButton`
                )(<Input />)}
              </Form.Item>
              {
                //แก้เป็น record
                record.abTimeDtId && (
                  <>
                    <Form.Item style={{ marginBottom: "0px" }} hidden>
                      {this.props.propFormInput.getFieldDecorator(
                        `tbAbstainTimeDt[${index}].abTimeDtId`,
                        {
                          initialValue: record.abTimeDtId,
                        }
                      )(<Input />)}
                    </Form.Item>
                    <Form.Item style={{ marginBottom: "0px" }} hidden>
                      {this.props.propFormInput.getFieldDecorator(
                        `tbAbstainTimeDt[${index}].abTimeHdId`,
                        {
                          initialValue: record.abTimeHdId,
                        }
                      )(<Input />)}
                    </Form.Item>
                  </>
                )
              }
            </>
          );
        },
      },

      {
        title: "วันที่",
        dataIndex: "startAbstainDate",
        keys: 5,
        vertical: "top",
        width: 130,
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {this.props.viewModeApproves && !this.props.isViewOnly ? (
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.propFormInput.getFieldDecorator(
                    `tbAbstainTimeDt[${index}].startAbstainDate`,
                    {
                      initialValue: item ? item : null,
                    }
                  )(
                    <DatePicker
                      format={this.dateFormatNumber(
                        `tbAbstainTimeDt[${index}].startAbstainDate`
                      )}
                      disabled={true}
                      className="w-100"
                      placeholder="เลือกวันที่"
                      allowClear={false}
                    />
                  )}
                </Form.Item>
              ) : (
                /* {this.findDiffDateTime(
                  moment(record.startAbstainDate),
                  moment(record.endAbstainDate)
                )} */

                changeFormatdate(item)
              )}
            </>
          );
        },
      },

      {
        title: "เวลาเริ่มงาน",
        dataIndex: "timeIn",
        keys: 6,
        vertical: "top",
        width: 100,
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {this.props.viewModeApproves && !this.props.isViewOnly ? (
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.propFormInput.getFieldDecorator(
                    `tbAbstainTimeDt[${index}].timeIn`,
                    {
                      initialValue: item ? item : null,
                    }
                  )(
                    <TimePicker
                      disabled={true}
                      placeholder={"-"}
                      //defaultValue={moment('12:00', timeFormat)}
                      format={timeFormat}
                      className="w-100"
                    />
                  )}
                </Form.Item>
              ) : (
                /* {this.findDiffDateTime(
                  moment(record.startAbstainDate),
                  moment(record.endAbstainDate)
                )} */

                item ? this.changeTimeToString(item) : "-"
              )}
            </>
          );
        },
      },
      {
        title: "เวลาออกงาน",
        dataIndex: "timeOut",
        keys: 7,
        width: 100,
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {this.props.viewModeApproves && !this.props.isViewOnly ? (
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.propFormInput.getFieldDecorator(
                    `tbAbstainTimeDt[${index}].timeOut`,
                    {
                      initialValue: item ? item : null,
                    }
                  )(
                    <TimePicker
                      disabled={true}
                      placeholder={"-"}
                      //defaultValue={moment('12:00', timeFormat)}
                      format={timeFormat}
                      className="w-100"
                    />
                  )}
                </Form.Item>
              ) : (
                item ? this.changeTimeToString(item) : "-"
              )}
            </>
          );
        },
      },
      {
        title: "สาเหตุแก้ไขการลงเวลาทำงาน",
        dataIndex: "description",
        keys: 8,
        width: 130,
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {this.props.viewModeApproves && !this.props.isViewOnly ? (
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.propFormInput.getFieldDecorator(
                    `tbAbstainTimeDt[${index}].description`,
                    {
                      initialValue: item ? item : null,
                      rules: [
                        {
                          required: true,
                          message: "กรุณาระบุสาเหตุแก้ไขการลงเวลาทำงาน",
                        },
                      ],
                    }
                  )(
                    <TextArea
                      // onBlur={(e) =>
                      //   this.onChangeSlectTable(e, "description")
                      // }
                      name={"description"}
                      disabled={record.disabledRow ? true : false}
                      //onblurdisabled={isViewOnly ? true : false}
                      style={{ width: "100%", height: "32px"}}
                    />
                  )}
                </Form.Item>
              ) : (
                <span>{item ? item : "-"}</span>
              )}
            </>
          );
        },
      },
      {
        title: "จัดการ",
        dataIndex: "8",
        keys: 9,
        width: 50,
        vertical: "top",
        align: "center",
        hidden:
          !this.props.viewModeApproves || this.props.isViewOnly ? true : false,
        render: (item, record, index) => {
          return this.showDetailBtnInput(record, index);
        },
      },
    ].filter((item) => !item.hidden),
    dataTalbeLength: 1,
  };

  onChangeSlectAll = async (value) => {
    const { propFormInput } = this.props;
    const { dataTableDate } = this.state;

    //let detailFormTable = propFormInput.getFieldValue("tbAbstainTimeDt");

    let detailFormTable = dataTableDate

    console.log("detailFormTable before", detailFormTable);
    console.log("detailFormTable value", value);
    // let arrayDelete = [...deleteAbstain, dataRecord.abTimeDtId];
    // console.log('arrayNewsDataTable', dataTalbe)
    // if(value){
    await detailFormTable.map((values, keys) => {
      console.log("detailFormTable map  isApprove", values);
      values.isApprove = value;
    });

    console.log("detailFormTable after", detailFormTable);

    await propFormInput.setFieldsValue({
      tbAbstainTimeDt: detailFormTable,
    });

    await this.setState({
      dataTableDate: detailFormTable,
    });

    // }else{
    //    await dataTalbe.map((values, keys)=>{
    //       values.statusCheckBox = value
    //       arrayNewsDataTable[keys] = values
    //    })
    // }
  };


 

  changeTimeToString = (time) => {
    const newsFormat = moment(time, 'HH:mm');

    const newdate = moment(newsFormat, "HH:mm:ss").format("HH:mm").toString()
        return newdate
  };

  dateFormatNumber = (values) => {
    const { propFormInput } = this.props;

    console.log("valueReturn values", values);
    let valueReturn = changeFormatdate(moment(propFormInput.getFieldValue(values)));
    console.log("valueReturn", valueReturn);

    return valueReturn;
  };

  dateFormatNumberForm = (values) => {
    const { form } = this.props;

    console.log("dateFormatNumberForm valueReturn values2", values);
    let valueReturn = form.getFieldValue(values);
    console.log("dateFormatNumberForm valueReturn2", valueReturn);

    let valueformat = changeFormatdate(valueReturn);
    console.log("dateFormatNumberForm valueformat", valueformat);

    return changeFormatdate(valueReturn);
  };

  showDataInputUploads = async (name, data, key) => {
    console.log("hi showdatainput func", name);
    console.log("record modal", data);
    await this.setState({
      ModalMode: name,
      ModalData: data ? data : null,
      DataRecordId: key,
      ModalCreateCCFormTitle:
        name == "create"
          ? "เพิ่มวันที่ขอแก้ไขการลงเวลาทำงาน"
          : "แก้ไขวันที่ขอแก้ไขการลงเวลาทำงาน",
      ModalCreateCCFormSubTitle: null,
      ModalCreateCCFormShowModal: true,
      ModalCreateCCFormBtnOk: "ยืนยัน",
      ModalCreateCCFormBtnCancel: "ปิด",
      ModalCreateCCFormValue: data,
      dataTalbeCheckBox: [],
      dataTalbeSearchCC: [],
      disabledDateStart: data?.startAbstainDate ? data?.startAbstainDate : null,
    });
  };

  hideModalCreateCC = async () => {
    await this.setState({
      ModalCreateCCFormTitle: null,
      ModalCreateCCFormSubTitle: null,
      ModalCreateCCFormShowModal: false,
      ModalCreateCCFormBtnOk: null,
      ModalCreateCCFormBtnCancel: null,
      ModalCreateCCFormValue: null,
      dataTalbeCheckBox: [],
      checkBoxTitle: false,
    });
  };

  enableToEdit = async (arrayId, data) => {
    console.log("hi Edit Row");
    const { dataTableDate } = this.state;
    const { propFormInput } = this.props;

    let getTimeDetail = propFormInput.getFieldValue("tbAbstainTimeDt");

    console.log("getTimeDetail", getTimeDetail);

    const mergeData = getTimeDetail.map((obj, _index) => ({
      ...obj,
      // ...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
      isShowSaveButton:
        _index == arrayId ? true : obj.isValidate == false ? true : false,
      isShowEditButton:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      disabledRow:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      isValidate:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
    }));

    await this.setState({ dataTableDate: mergeData });
    propFormInput.setFieldsValue({
      tbAbstainTimeDt: mergeData,
    });

    console.log("enableToEdit mergeData", mergeData);
    // setRow(mergeData);
    // formRef.current.setFieldsValue({
    //   studyScholarship:{
    //     studyScholarshipDetail : mergeData
    //   }
    // });
  };

  checkBeforeAddRow = async (arrayId) => {
    const { dataTableDate } = this.state;
    const { propFormInput } = this.props;

    const tableValue = dataTableDate.map((obj, _index) => ({
      ...obj,
      ...propFormInput.getFieldsValue()?.tbAbstainTimeDt[_index],
    }));

    // await this.setState({ disabledAdd: true });

    console.log("tableValue", tableValue);
    let lastRowValue = null;
    if (arrayId == "new") {
      console.log("arrayId = -1", arrayId);
      lastRowValue = tableValue[dataTableDate.length - 1];
    } else {
      console.log("arrayId != -1");
      lastRowValue = tableValue[arrayId];
    }

    // console.log("lastRowValue", lastRowValue);

    let errorValue = false;
    // let dupDateErrorReturnDate = false;
    // let dupDateErrorReturnDocument = false;

    // let errorYear = false;
    // console.log("errorYear studyLearnRecord", dataTalbeUploads);
    // console.log("errorYear before", errorYear);
    // if (dataTalbeUploads.length !== 0) {
    //   console.log("errorYear studyLearnRecord length hi");

    //   var valueArr = dataTalbeUploads.map(function (item) {
    //     return {
    //       studyLearnYear: item.studyLearnYear,
    //       studyLearnTerm: item.studyLearnTerm,
    //     };
    //   });

    //   var checkDuplicateArray = valueArr.filter(
    //     (v, i, a) =>
    //       a.findIndex(
    //         (t) =>
    //           t.studyLearnYear === v.studyLearnYear &&
    //           t.studyLearnTerm === v.studyLearnTerm
    //       ) === i
    //   );
    //       }
    if (
      lastRowValue.description == ""
    ) {
      errorValue = true;
      //TODO : specify empty field name in modal.error
      Modal.error({
        className: "modalFickIcons",
        title: "เพิ่มข้อมูลแก้ไขการลงเวลาทำงานไม่สำเร็จ",
        width: "600px",
        content: <h3 className="mt-3">กรุณาระบุสาเหตุแก้ไขการลงเวลาทำงาน</h3>,
        okText: "ปิด",
        onOk() {},
      });
    }
    // else if (checkDuplicateArray.length != dataTalbeUploads.length) {
    //   console.log("isDuplicate hi");
    //   Modal.error({
    //     className: "modalFickIcons",
    //     title: "เพิ่มข้อมูลผลการศึกษาไม่สำเร็จ",
    //     width: "600px",
    //     content: (
    //       <h3 className="mt-3">
    //         ไม่สามารถบันทึกภาคการศึกษาและปีการศึกษาซ้ำได้
    //       </h3>
    //     ),
    //     okText: "ปิด",
    //     onOk() {},
    //   });
    // }
    // else {
    //   let arrayCheckDup = null;

    //   if (arrayId == "new") {
    //     arrayCheckDup = tableValue.slice(0, -1);
    //     console.log("table value slice", arrayCheckDup);
    //   } else {
    //     arrayCheckDup = tableValue;
    //   }

    // arrayCheckDup.map((values, keys) => {
    //   console.log("keys", keys.toString());
    //   console.log("arrayId before checkdate", arrayId.toString());

    //   if (keys != arrayId && values.isValidate) {
    //     if (
    //       moment(lastRowValue.studyLeaveReturnDate).format("YYYY/MM/DD") == moment(values.studyLeaveReturnDate).format("YYYY/MM/DD")
    //     ) {
    //       dupDateErrorReturnDate = true;
    //     }
    //     else if(lastRowValue.studyLeaveReturnDocument == values.studyLeaveReturnDocument){
    //       dupDateErrorReturnDocument = true;
    //     }

    //   }
    // });

    //}

    // if (!errorValue && !dupDateErrorReturnDate && !dupDateErrorReturnDocument && checkDuplicateArray.length == dataTalbeUploads.length) {
    //   if (arrayId == "new") {
    //     console.log("handleaddrow");
    //     this.showDataInputUploads();
    //   } else {
    //     console.log("handleEditRow");
    //     this.handleEditRow(arrayId);
    //   }
    // }

    if(!errorValue){
       this.handleEditRow(arrayId);
    }
   
  };

  handleEditRow = async (arrayId) => {
    const { dataTableDate } = this.state;
    const { propFormInput } = this.props;

    let getTimeDetail = propFormInput.getFieldValue("tbAbstainTimeDt");

    const mergeData = getTimeDetail.map((obj, _index) => ({
      ...obj,
      //...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
      // studyExtendRound: _index + 1,
      // studyExtendSort: _index + 1,
      disabledRow:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      isShowEditButton:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      isShowSaveButton:
        _index == arrayId ? false : obj.isValidate == false ? true : false,
      isValidate:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
    }));

    await this.setState({ dataTableDate: mergeData });

    propFormInput.setFieldsValue({
      tbAbstainTimeDt: mergeData,
    });

    // let enableAddButton = true;
    // mergeData.map((resultObj, _index) => {
    //   if (!resultObj.isValidate) {
    //     enableAddButton = false;
    //   }
    // });

    // if (enableAddButton) {
    //   await this.setState({ disabledAdd: false });
    // } else {
    //   await this.setState({ disabledAdd: true });
    // }
  };

  showDetailBtnInput = (record, arrayId) => {
    const { isViewOnly } = this.props;
    const { dataTalbe, dataTableDate } = this.state;

    return (
      <>
        {record.isShowEditButton && (
          <Avatar
            shape="square"
            icon={<Icon type="edit" />}
            className="mr-2 mb-1"
            style={{ cursor: "pointer", backgroundColor: "#36699E" }}
            onClick={() => this.enableToEdit(arrayId, record)}
          />
        )}
        {record.isShowSaveButton && (
          <Avatar
            shape="square"
            icon={<Icon type="save" />}
            className="mr-2 mb-1"
            style={{ cursor: "pointer", backgroundColor: "#36699E" }}
            onClick={() => this.checkBeforeAddRow(arrayId)}
          />
        )}
        <Avatar
          shape="square"
          icon={<Icon type="delete" />}
          className={`mr-1 mb-1`}
          onClick={() =>
            !isViewOnly ? this.destroyArrayDataUploads(arrayId, record) : ""
          }
          style={{
            cursor: !isViewOnly ? "pointer" : "no-drop",
            background: !isViewOnly ? "red" : "#9d9d9d",
          }}
        />
        {/* <Avatar
          shape="square"
          icon={<Icon type="form" />}
          className={`ml-2 mb-1`}
          onClick={() =>
            !isViewOnly
              ? this.showDataInputUploads("edit", record, arrayId)
              : ""
          }
          style={{
            cursor: !isViewOnly ? "pointer" : "no-drop",
            background: !isViewOnly ? "red" : "#9d9d9d",
          }}
        /> */}
      </>
    );
  };

  destroyArrayDataUploads = async (arrayId, dataRecord) => {
    const { propFormInput } = this.props;
    const { dataTalbe } = this.state;
    // var arrayDataSource = [...this.state.dataTableDate];
    var arrayDataSource = propFormInput.getFieldValue("tbAbstainTimeDt");
    arrayDataSource.splice(arrayId, 1);

    console.log("arrayDataSource before", arrayDataSource);
    console.log("destroyArray", arrayId);

    if (dataRecord?.abTimeDtId) {
      let deleteAbstain = propFormInput.getFieldValue("abstainTimeDelete");
      let arrayDelete = [...deleteAbstain, dataRecord.abTimeDtId];
      propFormInput.setFieldsValue({
        abstainTimeDelete: arrayDelete,
      });
    }

    await this.setState(
      {
        dataTableDate: arrayDataSource,
      }
      // async () => {

      //   // let lengthData = arrayDataSource.length;
      //   // await this.setState({
      //   //   dataTalbeLength: lengthData,
      //   // });

      //   const fieldsBeforeMap = propFormInput.getFieldsValue();
      //   //const { studyRecord } = fields
      //   console.log("studyRecord fieldsBefore map", fieldsBeforeMap);

      //   console.log("arrayDataSource.file", arrayDataSource);
      //   arrayDataSource.map(async (valuesTable, keysTable) => {
      //     let startAbstainDate = `startAbstainDate${keysTable}`;
      //     let timeIn = `timeIn${keysTable}`;
      //     let timeOut = `timeOut${keysTable}`;
      //     let description = `description${keysTable}`;
      //     let listNo = `listNo${keysTable}`;
      //     let isShowEditButton = `isShowEditButton${keysTable}`;
      //     let isShowSaveButton = `isShowSaveButton${keysTable}`;
      //     let isValidate = `isValidate${keysTable}`;
      //     let disabledRow = `disabledRow${keysTable}`;

      //     const fieldsBefore = this.props.propFormInput.getFieldsValue();
      //     //const { studyRecord } = fields
      //     console.log("studyRecord fieldsBefore2", fieldsBefore);

      //     await propFormInput.setFieldsValue({
      //       [startAbstainDate]: valuesTable.startAbstainDate,
      //       [timeIn]: valuesTable.timeIn,
      //       [timeOut]: valuesTable.timeOut,
      //       [description]: valuesTable.description,
      //       [listNo]:valuesTable.listNo,
      //       [isShowEditButton]: valuesTable.isShowEditButton,
      //       [isShowSaveButton]: valuesTable.isShowSaveButton,
      //       [isValidate]: valuesTable.isValidate,
      //       [disabledRow]: valuesTable.disabledRow,
      //     });
      //     // console.log("arrayDataSource valuesTable.file", valuesTable);
      //     // console.log("arrayDataSource this.props.propFormInput", this.props.propFormInput);
      //     const fieldsX = this.props.propFormInput.getFieldsValue();
      //     //const { studyRecord } = fields
      //     console.log("studyRecord map", fieldsX);
      //   });
      //   const fields = this.props.propFormInput.getFieldsValue();
      //   //const { studyRecord } = fields
      //   console.log("studyRecord", fields);
      //   console.log("arrayDataSource after", arrayDataSource);
      // }
    );
    propFormInput.setFieldsValue({
      tbAbstainTimeDt: arrayDataSource,
    });
  };

  onChangeSlectTable = async (value, name) => {
    const { dataModalSelectDate } = this.state;
    let dataSourceitems = { ...dataModalSelectDate };

    console.log("dataSourceitems name", name);

    if (name == "description") {
      dataSourceitems.description = value.target.value;
    } else if (name == "startDate") {
      dataSourceitems.startDate = moment(value);
    } else if (name == "endDate") {
      dataSourceitems.endDate = moment(value);
    }

    console.log("dataSourceitems", dataSourceitems);
    await this.setState({
      dataModalSelectDate: dataSourceitems,
    });
  };

  findDiffDateTime(date1, date2) {
    console.log("date1", date1);
    console.log("date2", date2);

    var dateCal1 = new Date(date1);
    var dateCal2 = new Date(date2);
    var Difference_In_Time = dateCal2.getTime() - dateCal1.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    console.log("Difference_In_Days", Difference_In_Days);
    console.log("Difference_In_Days parseInt", Difference_In_Days.toFixed(0));

    return parseInt(Difference_In_Days.toFixed(0)) + 1;

    const { token } = getToken();
    const { empCode } = this.props;

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    console.log("123121response23", empCode);

    return axios
      .post(
        `${UrlAbstainTime()}/getWorkingDay`,
        {
          empCode: empCode,
          startDate: date1.format("YYYY/MM/DD"),
          endDate: date2.format("YYYY/MM/DD"),
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("Cal diff date", response.data.data.day);
        // resolve(response.data.data.day)
        return response.data.data.day;
      })

      .catch((error) => console.error(`Error: ${error}`));
  }

  onChangeCheck = async (e, index) => {
    console.log("e.target.checked", e.target.checked);
    const { propFormInput } = this.props;
    const { dataTableDate } = this.state;

    console.log("dataTableDate onchangecheck", dataTableDate);
    let dataMap = dataTableDate.map((values, keys) => {
      if (keys == index) {
        values.isApprove = e.target.checked;
      }
    });

    console.log("onChangeCheck dataMap", dataMap);

    // await propFormInput.setFieldsValue({
    //   tbAbstainTimeDt: dataMap,
    // });

    // await this.setState({
    //   dataTableDate: dataMap,
    // });
  };

  checkDuplicateBeforeCreate = async () => {
    const {} = this.props;
    const { dataTalbe, dataModalSelectDate, ModalMode, DataRecordId } =
      this.state;
    let row = [];
    let checkValue = [];
    let modalValue = [];
    let dataSourceitems = [...this.state.dataTableDate];
    let checkDateError = false;
    if (dataModalSelectDate) {
      dataSourceitems.map(async (dataItem, keys) => {
        if (
          changeFormatdate(dataModalSelectDate.startDate) ==
          changeFormatdate(dataItem.startAbstainDate)
        ) {
          console.log("dup modal value", dataModalSelectDate.startDate);
          console.log("dup", dataItem.startAbstainDate);
          console.log("DataRecordId", DataRecordId);
          console.log("keys", keys);

          if (DataRecordId != keys) {
            console.log("keys", keys);
            checkDateError = true;
          }
        } else {
          console.log("not dup");
          console.log("notdup modal value", dataModalSelectDate.startDate);
          console.log("notdup", dataItem.startAbstainDate);
        }
      });
    }

    if (checkDateError == true) {
      alertMessage(
        "error",
        "ไม่สามารถระบุวันที่ซ้ำหรือวันที่อยู่ในช่วงเวลาเดิมได้"
      );
    } else {
      await this.onSubmitModalCreateCC();
    }
  };

  onSubmitModalCreateCC = async (values) => {
    const {} = this.props;
    const { dataTalbe, dataModalSelectDate, ModalMode, DataRecordId } =
      this.state;
    let row = [];
    let checkValue = [];
    let modalValue = [];
    let dataSourceitems = [...this.state.dataTableDate];
    let errDateZero = false;
    console.log("values onsubmitsend", values);

    if (ModalMode == "edit") {
      let dataItem = { ...dataSourceitems[DataRecordId] };
      dataItem.description = values.dataModalSelectDate.description;
      dataItem.startAbstainDate = values.dataModalSelectDate.startDate;
      dataItem.endAbstainDate = values.dataModalSelectDate.endDate;
      dataItem.abstainDays = await this.findDiffDateTime(
        moment(values.dataModalSelectDate.startDate),
        moment(values.dataModalSelectDate.endDate)
      );

      if (dataItem.abstainDays == 0) {
        errDateZero = true;
      } else {
        dataSourceitems[DataRecordId] = dataItem;
      }
    } else {
      modalValue.description = values.dataModalSelectDate.description;
      modalValue.startAbstainDate = values.dataModalSelectDate.startDate;
      modalValue.endAbstainDate = values.dataModalSelectDate.endDate;

      //   await Promise.all(
      //     [
      //       modalValue.abstainDays = this.findDiffDateTime(
      //         moment(values.dataModalSelectDate.startDate),
      //         moment(values.dataModalSelectDate.endDate)
      //       )
      //     ]
      //  ).then((values) => {
      //     modalValue.abstainDays = values[0]

      //     // this.fetchListLearningESS()
      //   });

      modalValue.abstainDays = await this.findDiffDateTime(
        moment(values.dataModalSelectDate.startDate),
        moment(values.dataModalSelectDate.endDate)
      );

      console.log("modalValue", modalValue.abstainDays);
      if (modalValue.abstainDays == 0) {
        errDateZero = true;
      } else {
        row.push(modalValue);
      }

      // modalValue.abstainDays = this.findDiffDateTime(
      //   moment(values.dataModalSelectDate.startDate),
      //   moment(values.dataModalSelectDate.endDate)
      // );

      console.log("asdfasf", row);

      // row.push(modalValue);
    }

    if (dataModalSelectDate) {
      // if (ModalMode == "edit") {
      if (errDateZero) {
        Modal.error({
          className: "modalFickIcons",
          title:
            ModalMode == "edit"
              ? "แก้ไขวันที่ขอแก้ไขการลงเวลาทำงานไม่สำเร็จ"
              : "เพิ่มวันที่ขอแก้ไขการลงเวลาทำงานไม่สำเร็จ",
          width: "600px",
          content: <h3 className="mt-3">ไม่พบข้อมูลวันทำงาน</h3>,
          okText: "ปิด",
          onOk() {},
        });
      } else {
        await this.setState((prevState) => ({
          dataTableDate:
            ModalMode == "edit"
              ? dataSourceitems
              : [...prevState.dataTableDate, ...row],
          ModalCreateCCFormTitle: null,
          ModalCreateCCFormSubTitle: null,
          ModalCreateCCFormShowModal: false,
          ModalCreateCCFormBtnOk: null,
          ModalCreateCCFormBtnCancel: null,
          ModalCreateCCFormValue: null,
          dataTalbeCheckBox: [],
          checkBoxTitle: false,
          disabledDateStart: null,
        }));
      }

      // } else {
      //   await this.setState((prevState) => ({
      //     dataTableDate: [...prevState.dataTableDate, ...row],
      //     ModalCreateCCFormTitle: null,
      //     ModalCreateCCFormSubTitle: null,
      //     ModalCreateCCFormShowModal: false,
      //     ModalCreateCCFormBtnOk: null,
      //     ModalCreateCCFormBtnCancel: null,
      //     ModalCreateCCFormValue: null,
      //     dataTalbeCheckBox: [],
      //     checkBoxTitle: false,
      //   }));
      // }
    }
    // else {
    //   alertMessage("error", "กรุณาเลือกอย่างน้อย 1 รายการ");
    // }
  };

  onChangeValueDateStart = async (e) => {
    const { DateEndValue } = this.state;
    const {} = this.props;

    var date = new Date(e);

    const start = this.props.form.getFieldsValue();
    console.log("staty", start);
    console.log("staty e", e);

    if (start.dataModalSelectDate.endDate == "") {
      await this.props.form.setFieldsValue({
        dataModalSelectDate: {
          endDate: e,
        },
      });
    }

    console.log("new Date(e);", date);
    console.log("new Date(e);", DateEndValue);
    date.setDate(date.getDate() - 1);

    this.setState({
      disabledDateStart: moment(date).endOf("day"),
    });

    if (moment(start.dataModalSelectDate.endDate).isBefore(moment(e))) {
      console.log("end date lesser", this.props.form.getFieldsValue());
      this.props.form.setFieldsValue({
        dataModalSelectDate: {
          endDate: e,
        },
      });
    }

    await this.onChangeSlectTable(e, "startDate");
  };

  onChangeValueDateEnd = async (e) => {
    this.setState({
      DateEndValue: e,
    });
    await this.onChangeSlectTable(e, "endDate");
  };

  getDateList = async () => {
    const { token } = getToken();
    const { propFormInput, empCode } = this.props;
    const { dataTableDate } = this.state;

    const getFieldDate = this.props.form.getFieldsValue();

    let dataTalbeArray = [];

    console.log("getFieldDate", getFieldDate);

    await this.setState({
      loading: true,
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(`${UrlAbstainTime()}/getDateList`, {
        params: {
          empCode: empCode.toString(),
           startDate: moment(getFieldDate.dataModalSelectDate.startDate).format('YYYY-MM-DD').toString(),
           endDate: moment(getFieldDate.dataModalSelectDate.endDate).format('YYYY-MM-DD').toString()
          //empCode: "5594825",
          // startDate: "2020-10-01",
          // endDate: "2021-09-30",
        },
        headers: headers,
      })
      .then(async (response) => {
        console.log("response.data.data", response.data.data);
        console.log("response.status", response.data);

        if (response.data.data.length > 0) {
          response.data.data.map((valuesTable, keys) => {
            valuesTable.startAbstainDate = moment(
              valuesTable.date,
              "YYYY-MM-DD"
            );
            valuesTable.timeIn = valuesTable.timeIn ? moment(valuesTable.timeIn, "HH:mm") : null;
            valuesTable.timeOut = valuesTable.timeOut ? moment(valuesTable.timeOut, "HH:mm"): null;
            // valuesTable.timeIn = moment(valuesTable.timeIn).format("HH:mm")
            // valuesTable.timeOut = moment(valuesTable.timeOut).format("HH:mm")
            valuesTable.description = "";
            valuesTable.description = "";
            valuesTable.listNo = keys;
            valuesTable.isShowEditButton = true;
            valuesTable.isShowSaveButton = false;
            valuesTable.isValidate = true;
            valuesTable.disabledRow = true;

            delete valuesTable.date;
            // delete valuesTable.timeIn;
            // delete valuesTable.timeIn;
            delete valuesTable.dateType;
            dataTalbeArray.push(valuesTable);
          });

          console.log("dataTalbeArrayyyy", dataTalbeArray);

          let arraySum = [];
          if (dataTableDate.length > 0) {
            // dataTableDate.map((valuesTableDate, keys) => {
            //   console.log(
            //     "HEY DUP startAbstainDate",
            //     valuesTableDate.startAbstainDate
            //   );
            //   console.log(
            //     "HEY DUP startDate",
            //     moment(getFieldDate.dataModalSelectDate.startDate).format(
            //       "YYYY-MM-DD"
            //     )
            //   );
            //   console.log(
            //     "HEY DUP endDate",
            //     moment(getFieldDate.dataModalSelectDate.endDate).format(
            //       "YYYY-MM-DD"
            //     )
            //   );
            //   if (
            //     moment(valuesTableDate.startAbstainDate).isBetween(
            //       moment(getFieldDate.dataModalSelectDate.startDate).format(
            //         "YYYY-MM-DD"
            //       ),
            //       moment(getFieldDate.dataModalSelectDate.endDate).format(
            //         "YYYY-MM-DD"
            //       )
            //     ) ||
            //     moment(valuesTableDate.startAbstainDate).isSame(
            //       moment(getFieldDate.dataModalSelectDate.startDate).format(
            //         "YYYY-MM-DD"
            //       )
            //     ) ||
            //     moment(valuesTableDate.startAbstainDate).isSame(
            //       moment(getFieldDate.dataModalSelectDate.endDate).format(
            //         "YYYY-MM-DD"
            //       )
            //     )
            //   ) {
            //     console.log("HEY DUP!!", valuesTableDate.startAbstainDate);
            //     if (
            //       valuesTableDate.description != "" ||
            //       valuesTableDate.description
            //     ) {
            //       console.log(
            //         "HEY DUP!!!! with desc! ",
            //         valuesTableDate.startAbstainDate
            //       );
            //       arraySum.push(valuesTableDate);
            //     }
            //   }
            // });

            console.log("arraySum", arraySum);

            //             let arrayFinalDup = []
            if (arraySum) {
              //               dataTalbeArray.map((valuesTableDate, keys) => {

              //                 let dayLikeResult = this.checkDateLike(valuesTableDate.startAbstainDate,arraySum)

              //                 if(dayLikeResult){
              //                   console.log("dayLikeResult afterSum",dayLikeResult)
              //                   valuesTableDate.description = dayLikeResult[0].description

              //                 }
              //                 arrayFinalDup.push(valuesTableDate)

              //                })

              // console.log("arrayFinalDup afterSum",arrayFinalDup)

              let getTimeDetail = propFormInput.getFieldValue("tbAbstainTimeDt");

              let diffArr = dataTalbeArray.filter(
                (val) =>
                  !getTimeDetail.some((item) =>
                    moment(val.startAbstainDate).isSame(item.startAbstainDate)
                  )
              );

              console.log("diffArr", diffArr);
              const concatArr = diffArr.concat(getTimeDetail);
              const newArr = concatArr.sort((a, b) => {
                return (
                  new Date(a.startAbstainDate) - new Date(b.startAbstainDate)
                );
              });
              console.log("newArr", newArr);
              await this.setState({ dataTableDate: newArr });

              propFormInput.setFieldsValue({
                tbAbstainTimeDt: newArr,
              });

            } else {
              await this.setState({ dataTableDate: dataTalbeArray });

              propFormInput.setFieldsValue({
                tbAbstainTimeDt: dataTalbeArray,
              });
            }
          } else {
            await this.setState({ dataTableDate: dataTalbeArray });

            propFormInput.setFieldsValue({
              tbAbstainTimeDt: dataTalbeArray,
            });
          }
        }
        else{
            Modal.error({
              className: "modalFickIcons",
              title:
            "เพิ่มวันที่ขอแก้ไขการลงเวลาทำงานไม่สำเร็จ",
              width: "600px",
              content: <h3 className="mt-3">ไม่พบข้อมูลวันทำงาน</h3>,
              okText: "ปิด",
              onOk() {},
            });

            await this.setState({ dataTableDate: [] });

            propFormInput.setFieldsValue({
              tbAbstainTimeDt: null,
            });
          }      
      })
      .catch((error) => console.error(`Error: ${error}`));

    // let arrayDateTemp = [
    //   {
    //     isApprove: false,
    //     startAbstainDate: moment(),
    //     endAbstainDate: "-",
    //     listNo: "8.30",
    //     //abTimeDtId: "16.30",
    //     abTimeHdId: "-",
    //     abstainDays: "-",
    //     description: "1",
    //     abstainDays: "-",
    //     isShowEditButton: true,
    //     isShowSaveButton: false,
    //     isValidate: true,
    //     disabledRow: true,
    //   },
    //   {
    //     isApprove: false,
    //     startAbstainDate: moment(),
    //     endAbstainDate: "-",
    //     listNo: "8.30",
    //     //abTimeDtId: "16.30",
    //     abTimeHdId: "-",
    //     abstainDays: "-",
    //     description: "2",
    //     abstainDays: "-",
    //     isShowEditButton: true,
    //     isShowSaveButton: false,
    //     isValidate: true,
    //     disabledRow: true,
    //   },
    //   {
    //     isApprove: false,
    //     startAbstainDate: moment(),
    //     endAbstainDate: "-",
    //     listNo: "8.30",
    //     // abTimeDtId: "16.30",
    //     abTimeHdId: "-",
    //     abstainDays: "-",
    //     description: "3",
    //     abstainDays: "-",
    //     isShowEditButton: true,
    //     isShowSaveButton: false,
    //     isValidate: true,
    //     disabledRow: true,
    //   },
    // ]

    // console.log("arrayDateTemp",arrayDateTemp)

    // let getTimeDetail = propFormInput.getFieldValue("tbAbstainTimeDt");

    // const mergeData = getTimeDetail.map((obj, _index) => ({
    //   ...obj,
    //   //...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
    //   // studyExtendRound: _index + 1,
    //   // studyExtendSort: _index + 1,
    //   disabledRow:
    //    obj.isValidate == false ? false : true,
    //   isShowEditButton:
    //    obj.isValidate == false ? false : true,
    //   isShowSaveButton:
    //     obj.isValidate == false ? true : false,
    //   isValidate:
    //    obj.isValidate == false ? false : true,
    // }));
  };

  checkDateLike = (dateNew, arraySum) => {
    const { disabledDateStart } = this.state;
    console.log("dateNew", dateNew);
    console.log("arraySum", arraySum);

    let valueSum = [];
    arraySum.map((valuesTableDateSum, keys) => {
      if (moment(valuesTableDateSum.startAbstainDate).isSame(dateNew)) {
        valueSum.push(valuesTableDateSum);
        console.log("valueSum true!", valueSum);
      }
    });
    return valueSum;
  };

  disabledDate = (current) => {
    const { disabledDateStart } = this.state;
    console.log("disabledDateStart", disabledDateStart);
    console.log("current", current);
    return current && current < disabledDateStart;
  };

  sumRecordDate = (firstDate, lastDate) => {
    let resultArrayDate = [];
    resultArrayDate.length = 0;
    const start = new Date(firstDate);
    const end = new Date(lastDate);
    let loop = new Date(start);

    console.log("resultArrayDate loop before loop", resultArrayDate);

    for (var i = start; i <= end; i.setDate(i.getDate() + 1)) {
      let temp = new Date(i);
      let formatDate = changeFormatdate(temp);
      resultArrayDate.push(formatDate);
    }
    console.log("resultArrayDate", resultArrayDate);
    return resultArrayDate;
  };

  createArrayDate = async () => {
    const { ModalMode, DataRecordId } = this.state;

    let recordDate = this.state.dataTableDate;
    let arrayDate = [];
    let arrayResult = [];
    console.log("recordDate", recordDate);

    recordDate.map(async (dataItem, keys) => {
      if (keys != DataRecordId) {
        arrayDate = this.sumRecordDate(
          dataItem.startAbstainDate,
          dataItem.endAbstainDate
        );
        console.log("arrayDate", arrayDate);
        arrayResult = arrayResult.concat(
          arrayDate.filter((item) => arrayResult.indexOf(item) < 0)
        );
        console.log("arrayResult", arrayResult);
      }
    });

    return arrayResult;
  };

  areEqual = (array1, array2) => {
    const output = array2.filter(function (obj) {
      return array1.indexOf(obj) !== -1;
    });

    return output;
  };

  formSendDate = async (e) => {
    const { form, afterSubmit, client } = this.props;
    const { telNo, otpToken, refCode, DataRecordId } = this.state;

    let dataSourceitems = [...this.state.dataTableDate];
    let checkDateError = false;
    let arrayRecordDate = [];
    let arrayModalDate = [];
    let checkDupDate = null;
    console.log("dataSourceitems check", dataSourceitems);
    await e.preventDefault();
    await this.setState({
      loading: true,
    });
    form.validateFields(async (err, values) => {
      if (!err) {
        if (values) {
          console.log("xxxaaadsasd", values);
          arrayRecordDate = await this.createArrayDate();
          console.log("xxxaaadsasd arrayRecordDate", arrayRecordDate);

          arrayModalDate = await this.sumRecordDate(
            values.dataModalSelectDate.startDate,
            values.dataModalSelectDate.endDate
          );
          console.log("xxxaaadsasd arrayModalDate", arrayModalDate);

          checkDupDate = this.areEqual(arrayRecordDate, arrayModalDate);
          console.log("xxxaaadsasd checkDupDate", checkDupDate);

          if (checkDupDate.length > 0) {
            console.log("xxxaaadsasd DUP!!");
            checkDateError = true;
          }
        }
        // if (values) {
        //   dataSourceitems.map(async (dataItem, keys) => {
        //     if (
        //       changeFormatdate(values.dataModalSelectDate.startDate) ==
        //       changeFormatdate(dataItem.startAbstainDate)
        //     ) {
        //       console.log(
        //         "dup modal value",
        //         values.dataModalSelectDate.startDate
        //       );
        //       console.log("dup", dataItem.startAbstainDate);
        //       if (DataRecordId != keys) {
        //         console.log("keys", keys);
        //         checkDateError = true;
        //       }
        //     } else {
        //       console.log("not dup");
        //       console.log(
        //         "notdup modal value",
        //         values.dataModalSelectDate.startDate
        //       );
        //       console.log("notdup", dataItem.startAbstainDate);
        //     }
        //   });
        // }
        if (checkDateError == true) {
          alertMessage(
            "error",
            "ไม่สามารถระบุวันที่ซ้ำหรือวันที่อยู่ในช่วงเวลาเดิมได้"
          );
        } else {
          await this.onSubmitModalCreateCC(values);
        }
      } else {
        console.log("ERROR ENTER DATE!!", err);
      }
    });
  };

  async componentDidMount() {
    const { rawData, propFormInput, isViewOnly, statusDo, empCode, approveStatus} = this.props;

    console.log("empCode abstaindate", empCode);
    console.log("rawData abstaindate", rawData);
    console.log("approveStatus abstaindate", approveStatus);
    
    // let arrayDateTemp = [
    //   {
    //     isApprove: false,
    //     startAbstainDate: moment(),
    //     endAbstainDate: "-",
    //     listNo: "8.30",
    //     //abTimeDtId: "16.30",
    //     abTimeHdId: "-",
    //     abstainDays: "-",
    //     description: "1",
    //     abstainDays: "-",
    //     isShowEditButton: true,
    //     isShowSaveButton: false,
    //     isValidate: true,
    //     disabledRow: true,
    //   },
    //   {
    //     isApprove: false,
    //     startAbstainDate: moment(),
    //     endAbstainDate: "-",
    //     listNo: "8.30",
    //     //abTimeDtId: "16.30",
    //     abTimeHdId: "-",
    //     abstainDays: "-",
    //     description: "2",
    //     abstainDays: "-",
    //     isShowEditButton: true,
    //     isShowSaveButton: false,
    //     isValidate: true,
    //     disabledRow: true,
    //   },
    //   {
    //     isApprove: false,
    //     startAbstainDate: moment(),
    //     endAbstainDate: "-",
    //     listNo: "8.30",
    //     // abTimeDtId: "16.30",
    //     abTimeHdId: "-",
    //     abstainDays: "-",
    //     description: "3",
    //     abstainDays: "-",
    //     isShowEditButton: true,
    //     isShowSaveButton: false,
    //     isValidate: true,
    //     disabledRow: true,
    //   },
    // ]

    if (rawData) {
      const mergeData = rawData.map((obj, _index) => ({
        ...obj,
        //...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
        // studyExtendRound: _index + 1,
        // studyExtendSort: _index + 1,
        isApprove: obj.isApprove ? obj.isApprove : false,
        startAbstainDate: moment(obj.startAbstainDate),
        endAbstainDate: moment(obj.endAbstainDate),
        
        listNo: _index,
        //abTimeDtId: "16.30",
        // abTimeHdId: "-",
        abstainDays: "-",
        //description: _index,
        abstainDays: "-",
        timeIn: obj.timeIn ? moment(obj.timeIn,"HH:mm") : null,
        timeOut: obj.timeOut ? moment(obj.timeOut,"HH:mm") : null,
        isShowEditButton: true,
        isShowSaveButton: false,
        isValidate: true,
        disabledRow: true,
      }));
      console.log("mergeData comp date", mergeData);

      await this.setState({ dataTableDate: mergeData });

      propFormInput.setFieldsValue({
        tbAbstainTimeDt: mergeData,
      });
    }

    // if (this.props.viewModeApproves) {
    //   let addOBJ = [
    //     ...this.state.columns,
    // {
    //    title: "เข้างาน",
    //    dataIndex: "row2",
    //    keys:2,
    //    align: "center",
    //    vertical: "top",
    //    width: 80,
    //    render: (item, record, index) => {
    //      return (
    //        <>
    //          <Form.Item style={{ marginBottom: "0px", padding: "0px" }}>
    //            {this.props.propFormInput.getFieldDecorator(
    //              `tbAbstainTimeDt[${index}].startAbstainDate`,
    //              {
    //                initialValue: item ? item : "",
    //              }
    //            )(<span>{item}</span>)}
    //          </Form.Item>
    //          {/* <span>{item}</span> */}
    //          {/* <span>{this.state.pageData.offset + index + 1}</span> */}
    //        </>
    //      );
    //    },
    // },
    // {
    //    title: "ออกงาน",
    //    dataIndex: "row3",
    //    keys:3,
    //    vertical: "top",
    //    align: "center",
    //    width: 80,
    //    render: (item, record, index) => {
    //      return (
    //        <>
    //          <Form.Item style={{ marginBottom: "0px" }}>
    //            {this.props.propFormInput.getFieldDecorator(
    //              `tbAbstainTimeDt[${index}].endAbstainDate`,
    //              {
    //                initialValue: item ? item : "",
    //              }
    //            )(<span>{item}</span>)}
    //          </Form.Item>
    //          {/* <span>{item}</span> */}
    //        </>
    //      );
    //    },
    // },
    //   {
    //     title: "จัดการ",
    //     dataIndex: "8",
    //     keys: 8,
    //     width: 100,
    //     vertical: "top",
    //     align: "center",
    //     render: (item, record, index) => {
    //       return this.showDetailBtnInput(record, index);
    //     },
    //   },
    // ];

    // console.log("addOBJ", addOBJ);
    // addOBJ.sort((a, b) => a.keys - b.keys);
    // await this.setState({ columns: addOBJ });

    // this.state.columns.splice(7, 1)
    //}
  }

  render() {
    const { isViewOnly, rawData } = this.props;
    const {
      columns,
      preLoadOnsubmit,
      ModalCreateCCFormTitle,
      ModalCreateCCFormShowModal,
      ModalCreateCCFormBtnOk,
      ModalCreateCCFormBtnCancel,
      ModalCreateCCFormValue,
      dataTableDate,
      ModalMode,
      ModalData,
      disabledDateStart,
    } = this.state;

    console.log("rawData abstaindate render", rawData);
    console.log("dataTableDate", dataTableDate);
    console.log("ModalData", ModalData);
    return (
      <>
        <Modal
          destroyOnClose={true}
          maskClosable={false}
          visible={ModalCreateCCFormShowModal}
          title={ModalCreateCCFormTitle}
          onCancel={() => {
            this.hideModalCreateCC();
          }}
          //value={ModalCreateCCFormValue}
          footer={null}
          width={500}
          okText={ModalCreateCCFormBtnOk}
          cancelText={ModalCreateCCFormBtnCancel}
        >
          <Form onSubmit={this.formSendDate}>
            <Row gutter={16} type="flex" justify="left" align="top">
              <Col xs={24} md={24} style={{ margin: "auto" }}>
                <Row type="flex" justify="left" align="top">
                  <Col xs={12} md={12}>
                    <Form.Item label={"วันที่เริ่มต้น"} className="mb-0 mr-2">
                      {this.props.form.getFieldDecorator(
                        `dataModalSelectDate.startDate`,
                        {
                          initialValue: ModalData?.startAbstainDate
                            ? moment(ModalData.startAbstainDate)
                            : "",
                          rules: [
                            {
                              required: true,
                              message: "กรุณาเลือกวันที่เริ่มต้น",
                            },
                          ],
                        }
                      )(
                        <DatePicker
                          format={this.dateFormatNumberForm(
                            `dataModalSelectDate.startDate`
                          )}
                          className="w-100"
                          placeholder="เลือกวันที่"
                          //onChange={(e) => this.onChangeValueDateStart(e)}
                          allowClear={false}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Item label={"วันที่สิ้นสุด"} className="mb-0 ml-2">
                      {this.props.form.getFieldDecorator(
                        `dataModalSelectDate.endDate`,
                        {
                          initialValue: ModalData?.endAbstainDate
                            ? moment(ModalData.endAbstainDate)
                            : "",
                          rules: [
                            {
                              required: true,
                              message: "กรุณาเลือกวันที่สิ้นสุด",
                            },
                          ],
                        }
                      )(
                        <DatePicker
                          disabledDate={this.disabledDate}
                          disabled={
                            disabledDateStart || ModalData ? false : true
                          }
                          format={this.dateFormatNumberForm(
                            `dataModalSelectDate.endDate`
                          )}
                          className="w-100"
                          placeholder="เลือกวันที่"
                          //onChange={(e) => this.onChangeValueDateEnd(e)}
                          allowClear={false}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={24} className="mt-2">
                    <Form.Item
                      label={"สาเหตุการขอแก้ไขการลงเวลาทำงาน"}
                      style={{ marginBottom: "0px" }}
                      rules={[
                        { max: 255, message: "จำนวนตัวอักษรเกินกำหนด(255)" },
                      ]}
                    >
                      {this.props.form.getFieldDecorator(
                        `dataModalSelectDate.description`,
                        {
                          initialValue: ModalData ? ModalData.description : "",
                          rules: [
                            {
                              required: true,
                              message: "กรุณาระบุสาเหตุการขอแก้ไขการลงเวลาทำงาน",
                            },
                          ],
                        }
                      )(
                        <TextArea
                          onBlur={(e) =>
                            this.onChangeSlectTable(e, "description")
                          }
                          name={"description"}
                          onblurdisabled={isViewOnly ? true : false}
                          style={{ width: "100%" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={24} align={"center"} className="mt-4">
                <Button
                  type="primary"
                  className="mx-2 btn-white-red"
                  onClick={this.hideModalCreateCC}
                >
                  ยกเลิก
                </Button>
                <Button
                  type="primary"
                  className="ml-2 color-white"
                  htmlType="submit"
                  // onClick={this.checkDuplicateBeforeCreate}
                >
                  ยืนยัน
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>

        <Row gutter={16} type="flex" justify="left" align="bottom">
          <Col xs={24} md={24} className="mt-4">
            <strong className="color-red">ช่วงวันที่แก้ไขการลงเวลาทำงาน :</strong>
          </Col>

          {
            !isViewOnly &&
            (<><Col xs={12} md={8}>
            <Form.Item label={"วันที่เริ่มต้น"} className="mb-0 mr-2 mt-2">
              {this.props.form.getFieldDecorator(
                `dataModalSelectDate.startDate`,
                {
                  initialValue: ModalData?.startAbstainDate
                    ? moment(ModalData.startAbstainDate)
                    : "",
                  rules: [
                    {
                      required: true,
                      message: "กรุณาเลือกวันที่เริ่มต้น",
                    },
                  ],
                }
              )(
                <DatePicker
                  format={this.dateFormatNumberForm(
                    `dataModalSelectDate.startDate`
                  )}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  onChange={(e) => this.onChangeValueDateStart(e)}
                  allowClear={false}
                  disabled={isViewOnly ? true : false}
                />
              )}
            </Form.Item>
          </Col>
          <Col xs={12} md={8}>
            <Form.Item label={"วันที่สิ้นสุด"} className="mb-0 ml-2">
              {this.props.form.getFieldDecorator(
                `dataModalSelectDate.endDate`,
                {
                  initialValue: ModalData?.endAbstainDate
                    ? moment(ModalData.endAbstainDate)
                    : "",
                  rules: [
                    {
                      required: true,
                      message: "กรุณาเลือกถึง",
                    },
                  ],
                }
              )(
                <DatePicker
                  disabledDate={this.disabledDate}
                  disabled={
                    disabledDateStart || ModalData
                      ? false
                      : isViewOnly
                      ? true
                      : true
                  }
                  format={this.dateFormatNumberForm(
                    `dataModalSelectDate.endDate`
                  )}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  onChange={(e) => this.onChangeValueDateEnd(e)}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col></>)
          }
          
          {this.props.viewModeApproves && !isViewOnly && (
            <Col xs={12} md={5} className="mb-1">
              <Button
                type="primary"
                className="color-white"
                onClick={(e) => {
                  this.getDateList();
                }}
              >
                เพิ่ม
              </Button>
            </Col>
          )}
        </Row>
        <Row gutter={16} type="flex" justify="left" align="top">
          <Col xs={24} md={24} align={"right"} className="pt-4">
            <Table
              columns={columns}
              dataSource={dataTableDate}
              className="mb-3"
              bordered
              rowCount={dataTableDate.length}
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              pagination={false}
            />
            {/* {isViewOnly == false && (
               <Button
                  style={{ display: "inline-block" }}
                  className="mt-1 mr-2 y btn-color-default btn-custom btn-clear color-white"
                  type="primary"
                  disabled={preLoadOnsubmit}
                  onClick={() => this.showDataInputUploads("create")}
               >
                  เพิ่ม +
               </Button>
               )} */}
            <Form.Item style={{ marginBottom: "0px" }} hidden>
              {this.props.propFormInput.getFieldDecorator(`abstainTimeDelete`, {
                initialValue: [],
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  }
}

SecAbstainDate.defaultProps = {
  autoFocus: false,
};

SecAbstainDate.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedSecAbstainDate = Form.create()(SecAbstainDate);

export default withApollo(WrappedSecAbstainDate);
